import { Radio, RadioChangeEvent, Typography } from "antd";
import { CheckCircle, XCircle } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";

export const CorrectIncorrectOption = () => {

  const [checked, setChecked] = useState<boolean>();

  const handleChange = ({ target: { value } }: RadioChangeEvent) => {
    setChecked(value);

  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Radio.Group
        value={checked}
        style={{ width: "100%", textAlign: "center" }}
        onChange={handleChange}
      >
        <Radio value={true} style={{ flexDirection: "column-reverse" }}>
          <div
            style={{ width: "120px" }}
            className={
              checked ? "custom-radio-btn-checked" : "custom-radio-btn"
            }
          >
            <CheckCircle color="green" style={{ width: 48, height: 48 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
              Točno
            </Typography.Title>
          </div>
        </Radio>
        <Radio value={false} style={{ flexDirection: "column-reverse" }}>
          <div
            style={{ width: "120px" }}
            className={
              checked === false
                ? "custom-radio-btn-checked"
                : "custom-radio-btn"
            }
          >
            <XCircle color="red" style={{ width: 48, height: 48 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
              Netočno
            </Typography.Title>
          </div>
        </Radio>
      </Radio.Group>
    </motion.div>
  );
};
